import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  container: {
    marginTop: 70,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
  },
}));
